import { NavBar } from "../component/NavBar.jsx"
import { SideBar } from "../component/SideBar.jsx"

export const EventsPage = ()=>{
    return (
        <div>
        <NavBar/>
        <SideBar/>
        <div className="container">Events content </div>
        
        </div>
    )
};